import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faAngleDown} from '@fortawesome/free-solid-svg-icons';
import ProductAddonItem from './ProductAddonItem';

import React, {useEffect, useState} from 'react';

import styles from './style.module.css';
import {
  getLocaleCurrencySymbol,
  toThousand,
  toThousandLocaleCurrency,
} from '@lib/utils';
import {useProductDisplay} from '@contexts/index';
import {useRouter} from 'next/router';
import {LocaleEnum} from '@enums/locale';

function ProductAddons({product_group_id}: {product_group_id: string}) {
  const [active, setActive] = useState(false);
  const {state, onAccessorySelected} = useProductDisplay();
  const {linked_products, accessories} = state;
  const activeAccessory = linked_products[product_group_id];
  const productGroupAccessories = accessories[product_group_id];

  const onClick = ({accessory_id}: {accessory_id: number}) => {
    onAccessorySelected({accessory_id, product_group_id});
  };
  const router = useRouter();
  const locale = router.locale as unknown as LocaleEnum;

  useEffect(() => {}, []);

  const name = activeAccessory['product_name'];
  const {discount_unit_price_vat_included, unit_price_vat_included} =
    activeAccessory;

  return (
    <div className="productAddons">
      <div
        tabIndex={100}
        onClick={() => setActive(!active)}
        onBlur={() => setActive(false)}
        className={`${styles.productAddon} ${
          active && styles.activeProductAddon
        }`}
      >
        <span>
          <div>
            <h5>
              {name} +
              {toThousandLocaleCurrency(
                discount_unit_price_vat_included ?? unit_price_vat_included,
                locale
              )}
            </h5>
          </div>
          <FontAwesomeIcon icon={faAngleDown} />
        </span>
        <ul className={`${styles.productAddonItems}`}>
          {productGroupAccessories?.map((accessory, key) => {
            return (
              <ProductAddonItem
                isSelected={Number(accessory.id) === Number(activeAccessory.id)}
                onClick={() => onClick({accessory_id: accessory.id})}
                product_name={accessory['product_name']}
                price={accessory.unit_price_vat_included}
                product_id={accessory.id}
                product_image={accessory.images[0]?.image}
                key={key}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
}

export default React.memo(ProductAddons);
